import { render, staticRenderFns } from "./BackOfficeApp.vue?vue&type=template&id=e3066f34"
import script from "./BackOfficeApp.vue?vue&type=script&lang=js"
export * from "./BackOfficeApp.vue?vue&type=script&lang=js"
import style0 from "./BackOfficeApp.vue?vue&type=style&index=0&id=e3066f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports